import * as React from 'react';
import format from 'string-format';
import * as fr from "./../../i18n/fr.json";
import * as en from "./../../i18n/en.json";
import { Language } from '../../_helpers/Languages';
type TranslateProps = {
    id: string,
    description?: string;
    defaultMessage?: string;
    values?: {} | string[] | string;
};
export const Translate = (props:TranslateProps) => {
    const { id, defaultMessage, values } = props;
    let template: string | undefined = ""
    switch (Language) {
        case 'fr':
            template = fr[id];
            break;
        case 'en':
            template = en[id];
            break;
        default:
            template = defaultMessage;
            break;
    }
    const message = template || defaultMessage || id;
    if (values !== undefined) { return format(message, values); }
    return message;
}
export const TranslatedMessage: React.SFC<{
    id: string,
    description?: string;
    defaultMessage?: string;
    values?: {} | string[] | string;
}> = (props) => {
    return <React.Fragment>{Translate(props)}</React.Fragment>;
};


// WEBPACK FOOTER //
// ./src/Components/TranslatedMessage/TranslatedMessage.tsx